<div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body" id="personnalisemenu">
    <h2 class="product-family">{{menu.category}}</h2>
    <h1 class="product-name">{{menu.title}}
        <span *ngIf="!menu.offer">({{menu.price}} €)</span>
    </h1>
    <div *ngIf="loader" id="loadingPage"></div>
    <div *ngIf="!loader" class="row">
        <div class="col-xs-12 col-sm-12">
            <ng-container *ngIf="loader">
                <div class="placeholder">
                    <div class="animated-background"></div>
                </div>
                <div class="placeholder2">
                    <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]">
                        <div class="animated-background"></div>
                    </ng-container>
                </div>
            </ng-container>
            <div>
                <ng-container *ngFor="let composition of menu.compositions2;let i=index">
                    <ng-container *ngIf="i==0 && composition.length>0">
                        <ng-container *ngFor="let comp of composition;let j=index">
                            <ng-container *ngIf="comp.type==1">
                                <ng-container *ngIf="comp as element">
                                    {{label}}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="comp.type==2">
                                <ng-container *ngIf="comp as fa">
                                    <ng-container *ngFor="let elements of fa.elements;let k=index">
                                        <panel [label2]="label" [id]="'choix_family_0_'+j+'_'+k" [content]="el">
                                            <ng-template #label>
                                                {{fa.label}}
                                                <ng-container *ngIf="fa.elements.length>1">
                                                    {{(k+1)}}
                                                </ng-container>
                                                <ng-container *ngIf="fa.level">
                                                    ({{fa.size}})
                                                </ng-container>
                                            </ng-template>
                                            <ng-template #el>
                                                <div class="famille_element">
                                                    <div class="display-grid">
                                                        <div *ngFor="let element of elements;let m=index"
                                                            class="rad-element">
                                                            <product-menu [(ngModel)]="fa.elements[k].selectedElement"
                                                                [value]='m' name="famille0_el{{k}}_{{m}}"
                                                                (OnPersonalize)="PersonalizeModal(element,0);fa.elements[k].selectedElement=m"
                                                                [product]="element"  [offer]="menu.offer"></product-menu>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </panel>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>

            <div class="all" *ngIf="!loader && menu.id && menu.compositions2?.length>0">
                <ng-container *ngFor="let composition of menu.compositions2;let i=index">
                    <ng-container *ngIf="i==0 && composition.length>0">
                        <ng-container *ngFor="let comp of composition;let j=index">
                            <ng-container *ngIf="comp.type==1">
                                <ng-container *ngIf="comp as element">
                                    <div>
                                        <div class="title titlemenu">
                                            <ng-container *ngIf="comp.quantity>1">
                                                {{element.quantity}}x
                                            </ng-container>
                                            {{element.name}}
                                            <ng-container *ngIf="element.level">
                                                ({{element.size}})
                                            </ng-container>
                                        </div>
                                        <div class="famille_element">
                                            <div class="display-grid">
                                                <product-menu (OnPersonalize)="PersonalizeModal(element,1)"
                                                    [product]="element"  [offer]="menu.offer"></product-menu>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="comp.type==2">
                                <ng-container *ngIf="comp as fa">
                                    <ng-container *ngFor="let elements of fa.elements;let k=index">
                                        <div>
                                            <div class="title titlemenu">
                                                {{fa.label}} 
                                                <ng-container *ngIf="fa.elements.length>1">
                                                    {{(k+1)}}
                                                </ng-container>
                                                <ng-container *ngIf="fa.level">
                                                    ({{fa.size}})
                                                </ng-container>
                                            </div>
                                            <div class="famille_element">
                                                <div class="display-grid">
                                                    <div *ngFor="let element of elements;let m=index"
                                                        class="rad-element">
                                                        <product-menu [(ngModel)]="fa.elements[k].selectedElement"
                                                            [value]='m' name="famille0_el{{k}}_{{m}}_{{j}}"
                                                            (OnPersonalize)="PersonalizeModal(element,0);fa.elements[k].selectedElement=m"
                                                            [product]="element"  [offer]="menu.offer"></product-menu>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="i>0 && composition.length>0">
                        <div>
                            <div class="title titlemenu">
                                Faites votre choix
                            </div>
                            <accordion [closeOthers]="true">
                                <accordion-group *ngFor="let comp of composition;let j=index">
                                    <div class="d-flex" accordion-heading>
                                        <input type="radio" class="option-input radio" [name]="'choix_'+i"
                                            [(ngModel)]="composition.checked" [value]='j'>
                                        <button class="btn btn-link btn-block acc-btn" (click)="composition.checked=j">
                                            <span class="badge badge-danger" *ngIf="comp.quantity>1">
                                                {{comp.quantity}}x
                                            </span>
                                            <ng-container *ngIf="comp.type==1">
                                                {{comp.name}}
                                            </ng-container>
                                            <ng-container *ngIf="comp.type==2">
                                                <span>{{comp.label}}</span>
                                            </ng-container>
                                            <ng-container *ngIf="comp.level">
                                                <span class="familySize">&nbsp; {{comp.size}}</span>
                                            </ng-container>
                                            <ng-container *ngIf="comp.size=='.'">
                                                <span class="familySize" style="color:black !important;">.</span>
                                            </ng-container>
                                        </button>
                                        <span class="float-right pull-right arrow">
                                            <img class="ret" height="17px" src="assets/imgs/right-arrow.svg">
                                        </span>
                                    </div>
                                    <div class="familyContent">
                                        <ng-container *ngFor="let comp of composition;let j=index">
                                            <div *ngIf="composition.checked==j" [class.wd]="comp.type==1">
                                                <ng-container *ngIf="comp.type==1">
                                                    <ng-container *ngIf="comp as element">
                                                        <product-menu name="el_{{i}}_{{j}}}"
                                                            (OnPersonalize)="PersonalizeModal(element,1)"
                                                            [product]="element"  [offer]="menu.offer"></product-menu>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="comp.type==2 && comp.elements.length>0">
                                                    <p class="alert alert-info" *ngIf="comp.elements.length>1">
                                                        Veuillez choisir {{comp.quantity}} {{comp.label|lowercase}}
                                                    </p>
                                                    <accordion [closeOthers]="true"
                                                        *ngIf="comp.elements.length>1;else temp">
                                                        <accordion-group *ngFor="let el of comp.elements;let k=index">
                                                            <div accordion-heading>
                                                                <button class="btn btn-link btn-block">
                                                                    <span style="color: #ddd;"
                                                                        class="pull-left float-left">
                                                                        CHOIX {{comp.label}} <span
                                                                            class="badge badge-warning">{{(k+1)}}</span>
                                                                    </span>
                                                                    <span class="float-right pull-right">
                                                                        <img height="17px"
                                                                            src="assets/imgs/right-arrow.svg">
                                                                    </span>
                                                                </button>
                                                            </div>
                                                            <div class="famille_element">
                                                                <div class="display-grid">
                                                                    <div *ngFor="let element of el;let l=index"
                                                                        class="rad-element">
                                                                        <product-menu
                                                                            [(ngModel)]="comp.elements[k].selectedElement"
                                                                            [value]='l'
                                                                            name="el_{{i}}_{{j}}_{{k}}_{{l}}"
                                                                            (OnPersonalize)="PersonalizeModal(element,1);comp.elements[k].selectedElement=l"
                                                                            [product]="element"  [offer]="menu.offer"></product-menu>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </accordion-group>
                                                    </accordion>
                                                    <ng-template #temp>
                                                        <div class="famille_element  element-b">
                                                            <div class="display-grid">
                                                                <div *ngFor="let element of comp.elements[0];let l=index"
                                                                    class="rad-element rad-e">
                                                                    <product-menu
                                                                        [(ngModel)]="comp.elements[0].selectedElement"
                                                                        [value]='l' name="el_{{i}}_{{j}}_{{l}}_0"
                                                                        (OnPersonalize)="PersonalizeModal(element,1);comp.elements[0].selectedElement=l"
                                                                        [product]="element"  [offer]="menu.offer"></product-menu>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </div>
                                </accordion-group>
                            </accordion>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
    <div *ngIf="!loader" class="product-comment">
        <textarea placeholder="Commentaire" name="comment" [(ngModel)]="menu.comment" rows="3"></textarea>
    </div>
    <button *ngIf="!loader" [disabled]="!enableAddButton" class="add-to-cart btn btn-block" (click)="addToBasket()">
        <i class="flaticon-shopping"></i>
        <span>Ajouter au panier</span>
    </button>
</div>